var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 82,
    viewBox: "0 0 93 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.8 81.2998C15.8 81.2998 10.2 78.7998 6 73.7998C2 68.5998 0 61.8998 0 53.6998C0 42.4998 3 32.3998 9 23.3998C15.2 14.1998 24.6 6.4998 37.2 0.299805L40.5 5.0998C34.5 8.6998 29 13.7998 24 20.3998C19.2 26.7998 16.8 33.2998 16.8 39.8998C16.8 41.6998 17.3 43.1998 18.3 44.3998C19.3 45.3998 20.8 45.8998 22.8 45.8998C27.8 45.8998 32 47.6998 35.4 51.2998C39 54.6998 40.8 58.8998 40.8 63.8998C40.8 68.8998 39 73.0998 35.4 76.4998C32 79.6998 27.8 81.2998 22.8 81.2998ZM74.7 81.2998C67.7 81.2998 62.1 78.7998 57.9 73.7998C53.9 68.5998 51.9 61.8998 51.9 53.6998C51.9 42.4998 54.9 32.3998 60.9 23.3998C67.1 14.1998 76.5 6.4998 89.1 0.299805L92.4 5.0998C86.4 8.6998 80.9 13.7998 75.9 20.3998C71.1 26.7998 68.7 33.2998 68.7 39.8998C68.7 41.6998 69.2 43.1998 70.2 44.3998C71.2 45.3998 72.7 45.8998 74.7 45.8998C79.7 45.8998 83.9 47.6998 87.3 51.2998C90.9 54.6998 92.7 58.8998 92.7 63.8998C92.7 68.8998 90.9 73.0998 87.3 76.4998C83.9 79.6998 79.7 81.2998 74.7 81.2998Z",
    fill: "#E7E9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.491dfcf871cc91144132218e1d3f60e0.svg";
export { ForwardRef as ReactComponent };